export const ContentWidth = {
  Fluid: 'fluid',
}
export const NavbarType = {
  Sticky: 'sticky',
}
export const FooterType = {
  Static: 'static',
}
export const AppContentLayoutNav = {
  Vertical: 'vertical',
}
